import React from 'react';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/ui/tooltip';
import { RoleBadge } from './RoleBadge';
import { useTeampageTranslations } from '@/hooks/useTeampageTranslations';

interface RoleDescriptionTooltipProps {
  roleName: string;
  description: string;
}

export const RoleDescriptionTooltip: React.FC<RoleDescriptionTooltipProps> = ({
  roleName,
  description,
}) => {
  const i18n = useTeampageTranslations();

  // Get translated description if available, otherwise use provided description
  const translatedDescription =
    roleName === 'Admin' ||
    roleName === 'Editor' ||
    roleName === 'Viewer' ||
    roleName === 'OrgOwner'
      ? i18n.roles[roleName]?.description || description
      : description;

  // If no description, just render the badge without tooltip
  if (!translatedDescription) {
    return <RoleBadge role={roleName} />;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <RoleBadge role={roleName} />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p className="max-w-xs text-sm">{translatedDescription}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RoleDescriptionTooltip;
